<script lang="ts">
	import { learnPageBtnsList } from 'utils/learn/filterBtnsList';
	import FilterButton from 'components/FilterButton/FilterButton.svelte';
	import FilterSelect from 'components/LearnPage/FilterSelect/FilterSelect.svelte';
	import { _ } from 'utils/i18/i18n';
	import { goto } from '$app/navigation';

	export let dark = false;
	export let handleCategory: (category: string) => void;
	export let handleQuery: (query: string) => void;
	export let handlePageChange: (page: number) => void;

	export let category = 'all';
</script>

<div class="filters" class:dark>
	<p class="description">{$_('learn.articlesTitle')}</p>
	<div class="filter-select">
		<FilterSelect
			{dark}
			variants={learnPageBtnsList}
			selectedFilter={category}
			handleFilter={handleCategory}
		/>
	</div>
	<ul class="filters-btn-list">
		{#each learnPageBtnsList as btn}
			<li class="filter-btn">
				<FilterButton
					as="button"
					{dark}
					title={btn.name}
					id={btn.name}
					isActive={btn.name.replaceAll(' ', '_') === category.replaceAll(' ', '_')}
					on:click={() => {
						category = btn.name;
						handleCategory(btn.name.replaceAll(' ', '_'));
						handleQuery('');
						handlePageChange(1);
						goto(category === 'all' ? '/learn' : `/learn/${btn.name.replaceAll(' ', '-')}`);
					}}
				/>
			</li>
		{/each}
	</ul>
</div>

<style lang="scss">
	@import 'articleFilters';
</style>
